import { client } from '@hotjar/api-base-client';
import type { SurveyDto } from './survey-dto';
import type { SurveyModel } from './survey-model';

export async function getChurnSurvey(): Promise<SurveyModel> {
  const data = await client<SurveyModel, SurveyDto>({
    url: '/api/v1/sites/14/surveys/churn?survey_v2=true',
  });

  return data;
}
